// src/components/Dashboard/Dashboard.tsx
import React, { useState, useEffect } from 'react';
import '../../styles/dashboard.css'; // Импортируем CSS
import DashboardHeader from './DashboardHeader';
import DashboardNav from './DashboardNav';
import WelcomeSection from './WelcomeSection';
import SectionsGrid from './SectionsGrid';
import RobotsSection from './RobotsSection';
import { Robot } from '../../types';
import { useAuth } from '../../auth/AuthContext';

// Mock данные для роботов
const mockRobots: Robot[] = [
  { id: '001', name: 'Робот Alpha', status: 'online', battery: '85%', lastSeen: 'Только что' },
  { id: '002', name: 'Робот Beta', status: 'offline', battery: '42%', lastSeen: '10 мин назад' },
  // Pi без шасси в эмуляторе (STATION_IDS): камера и микрофон, без езды и карты
  { id: '003', name: 'Gamma — Pi без шасси', status: 'online', battery: '-', lastSeen: 'Только что' },
  // Реальный робот через docker/esp32-bridge (id = ESP32_ROBOT_ID)
  { id: 'esp32', name: 'ESP32 (лидар)', status: 'offline', battery: '-', lastSeen: '-' },
  // Отдельно стоящий Pi с камерой и микрофоном (robot/rpi5/.../config/station.yaml, robot_id station)
  { id: 'station', name: 'Pi без шасси (камера, микрофон)', status: 'offline', battery: '-', lastSeen: '-' },
];

const Dashboard: React.FC = () => {
  const [robots, setRobots] = useState<Robot[]>([]);
  const { user, logout } = useAuth();

  useEffect(() => {
    // Здесь будет логика загрузки данных, например, из API
    setRobots(mockRobots);
  }, []);

  // После выхода RequireAuth сам перенаправит на /login
  const handleLogout = () => {
    logout();
  };

  return (
    <div className="dashboard">
      <DashboardHeader userName={user ?? ''} onLogout={handleLogout} />
      <DashboardNav />
      <main className="dashboard-main">
         {/* Используем flexbox для размещения приветствия и карточек */}
         <div className="welcome-and-sections-container">
          <WelcomeSection />
          <SectionsGrid />
        </div>        
        <RobotsSection robots={robots} />
      </main>
    </div>
  );
};

export default Dashboard;